import { render, staticRenderFns } from "./Choose.vue?vue&type=template&id=14e3f0c9&"
import script from "./Choose.vue?vue&type=script&lang=js&"
export * from "./Choose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/casperjureskog/CMM/creo-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14e3f0c9')) {
      api.createRecord('14e3f0c9', component.options)
    } else {
      api.reload('14e3f0c9', component.options)
    }
    module.hot.accept("./Choose.vue?vue&type=template&id=14e3f0c9&", function () {
      api.rerender('14e3f0c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/questions/Choose.vue"
export default component.exports